import { api } from '@/shared/api';
import { useUserStore } from '@/shared/model';

async function ensureUserResolved(): Promise<void> {
  const userStore = useUserStore();

  const user = await userStore.getUser();

  if (!user) {
    throw new Error('ERR_FREEDOM_PRIME_AUTHENTICATION_REQUIRED');
  }
}

export const freedomPrimeApi = {
  fetchLogin: async (): Promise<string> => {
    await ensureUserResolved();

    return api.client
      .get<{ token: string }>('/freedom-prime/login')
      .then(response => response.data.token);
  },

  fetchSelfInfo: async (): Promise<unknown> => {
    await ensureUserResolved();

    return api.client
      .get<unknown>('/freedom-prime/self_info')
      .then(response => response.data);
  },
};
